import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAuthState } from "../../../../../MainComponents/GlobalContext";
import useAxios from "../../../../../MainComponents/Hooks/useAxios";

const Question = ({ state, dispatch, homework, exam }) => {
  const { ID } = useParams();

  const AuthState = useAuthState();

  const checkApi = homework
    ? process.env.REACT_APP_STUDENT_HOMEWORK_UPDATE_API
    : exam
    ? process.env.REACT_APP_STUDENT_TRIAL_EXAM_UPDATE_API
    : process.env.REACT_APP_STUDENT_QUIZZ_UPDATE_API;

  const [selectAnswerSuccess, selectAnswerErrors, selectAnswerLoading] =
    useAxios(
      checkApi,
      "POST",
      state.updateSelectedAnswer.flag,
      state.updateSelectedAnswer.dependency,
      state.updateSelectedAnswer.data
    );

  const handleSelectAnswer = (answer, questionId, n, answerId) => {
    dispatch({
      type: "setAnsweredQuestions",
      payload: { id: questionId, order: answer, n, answer_id: answerId },
    });

    let payload = {
      id: questionId,
      order: answer,
      answer_id: answerId,
      n,
    };

    if (exam) payload.exam_id = ID;
    else payload.lecture_id = ID;

    dispatch({
      type: "setUpdateSelectedAnswer",
      payload: {
        flag: "updateSelectedAnswer",
        dependency: !state.updateSelectedAnswer.dependency,
        data: payload,
      },
    });

    dispatch({
      type: "setIsSelectedAnswer",
      payload: { questionId, answer, n, answerId },
    });
  };

  useEffect(() => {
    if (selectAnswerSuccess) {
      dispatch({
        type: "setUpdateSelectedAnswer",
        payload: {
          flag: "",
          dependency: false,
          data: {},
        },
      });
    }
  }, [selectAnswerSuccess]);

  return (
    <div className="container max-w-full border-2 border-secondary p-8 rounded-2xl">
      <div className="current-question flex-row-reverse !justify-end bg-white shadow-lg	rounded-lg p-4 py-12">
        <div
          dangerouslySetInnerHTML={{
            __html: state.questions[state.currentQuestionIndex]?.question,
          }}
        />
        {`${state.currentQuestionIndex + 1}`}
      </div>

      <div className="current-question-degree">
        <p className="text-end">
          {" "}
          {state.questions[state.currentQuestionIndex]?.degree} درجه
        </p>
      </div>

      <div className="current-question-answers ">
        {state.questions[state.currentQuestionIndex]?.answers.map(
          (answer, i) => (
            <div
              key={i}
              className={`${
                state.questions[state.currentQuestionIndex].selected_answer ===
                  answer.order && "selected"
              } dark:bg-white `}
              onClick={() =>
                handleSelectAnswer(
                  answer.order,
                  state.questions[state.currentQuestionIndex].id,
                  state.questions[state.currentQuestionIndex].n,
                  answer.id
                )
              }
            >
              <p dangerouslySetInnerHTML={{ __html: answer.text }} />
              <span>{answer.order} </span>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Question;
